const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/middle-banner', {
  title: 'Banner Meio',
  description:
    'Banner editável com imagem de fundo, imagem pequena, texto e botão',
  icon: 'admin-site',
  category: 'design',
  attributes,
  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
